import { render, staticRenderFns } from "./ClienteLayout.vue?vue&type=template&id=cdfed4ae&"
import script from "./ClienteLayout.vue?vue&type=script&lang=js&"
export * from "./ClienteLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports